import ScreenWrapper from "@/components/ScreenWrapper"
import { checkTestSupportAccess } from "@/utils/checkTestSupportAccess"
import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/test-support")({
  beforeLoad: checkTestSupportAccess,
  component: TestSupportLayout,
})

function TestSupportLayout() {
  return (
    <ScreenWrapper>
      <Outlet />
    </ScreenWrapper>
  )
}
